import Typography from '@mui/material/Typography';
import { useMemo } from 'react';

import { IResponse, useDataProvider } from '@work4all/data';

import { DatevTenant } from '@work4all/models/lib/Classes/DatevTenant.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ListEntityPicker } from '../components/list-entity-picker/ListEntityPicker';
import { IPickerProps } from '../types';

export type IDatevTenantPickerProps<TMultiple extends boolean> = IPickerProps<
  DatevTenant,
  TMultiple
>;

export function DatevTenantPicker<TMultiple extends boolean>(
  props: IDatevTenantPickerProps<TMultiple>
) {
  const { data, ...rest } = props;

  const allFields = useMemo(() => {
    return { ...DATA_FIELDS, ...data };
  }, [data]);

  const requestData = useMemo<DataRequest>(() => {
    return {
      entity: Entities.datevTenant,
      data: allFields,
      completeDataResponse: true,
    };
  }, [allFields]);

  const response = useDataProvider(requestData);

  const dataset = useMemo<IResponse<DatevTenant>>(() => {
    return {
      ...response,
      total: response.data.length,
      fetchMore: () => Promise.resolve(),
      refetch: () => Promise.resolve(null),
    };
  }, [response]);

  return (
    <ListEntityPicker
      entity={Entities.datevTenant}
      data={allFields}
      filterBy={[]}
      sortBy="name"
      useSearchHistory={false}
      fixedDataSet={dataset}
      {...rest}
      favorites={false}
      renderItemContent={(datevTenant: DatevTenant) => (
        <Typography variant="body2" noWrap>
          {datevTenant.name}
        </Typography>
      )}
    />
  );
}

const DATA_FIELDS: DatevTenant = {
  id: null,
  clientNumber: null,
  consultantNumber: null,
  name: null,
  services: [
    {
      name: null,
      scopes: null,
    },
  ],
};
